import axios from "axios";
import jwt_decode from "jwt-decode";
import { getToken , hasAccess } from "./tokenCheck.js";
import { Capacitor } from "@capacitor/core";


function getProcessedToken() {
	if(getToken()){
	var decoded = jwt_decode(getToken());
	return decoded.sub;
	}
	else return null;
}

// ============================================================================
// AXIOS INSTANCES - Core Services
// ============================================================================

const KeynodeService = axios.create({
	baseURL: "https://keynode.hire3x.com/",
});

const EmailService = axios.create({
    baseURL: "https://candidate-api.hire3x.com",
});

const ServiceCandidate = axios.create();

ServiceCandidate.interceptors.request.use((config) => {
	// Dynamically set baseURL based on access level
	config.baseURL = hasAccess()
		? "https://gateway.hire3x.com/candidate/"
		: "https://candidate-api.hire3x.com";

	// Uncomment the line below for local backend testing
	// config.baseURL = "http://127.0.0.1:8000/";

	return config;
});

const ServiceCandidateParser = axios.create({
	baseURL: "https://resumeparser.hire3x.com",
});

const websiteRequest = axios.create({
	baseURL: "https://api-website.hire3x.com/",
})

const serviveNotification = axios.create({
	baseURL: "https://notification.hire3x.com/", //Production
});
const serviceRecruitment = axios.create();

serviceRecruitment.interceptors.request.use((config) => {
	config.baseURL = hasAccess()
		? "https://gateway.hire3x.com/recruitment/"
		: "https://recruitment-api.hire3x.com/";

	// Uncomment the line below for local backend testing
	// config.baseURL = "http://127.0.0.1:8000/";

	return config;
});

const serviceAssessment = axios.create({
	baseURL: "https://gateway.hire3x.com/assessment/",
});

const serviceRequest = axios.create({
	baseURL: "https://admin-api.hire3x.com/",
});

// ============================================================================
// AXIOS INSTANCES - Authentication & User Services
// ============================================================================

const SSOService = axios.create({
	baseURL: "https://auth.hire3x.com/",

});

const KeycloakAPIs = axios.create({
	baseURL: "https://keynode.hire3x.com/",
});

// ============================================================================
// AXIOS INSTANCES - Specialized Services
// ============================================================================

const ServiceAiInterviewer = axios.create({
	baseURL: "https://ai-interviewer.hire3x.com/",
});

const trainingService = axios.create({
	baseURL: "https://training-api.hire3x.com/",
});

const paymentService = axios.create({
	baseURL: "https://payment.hire3x.com/",
});

const notificationAuth = axios.create({
	baseURL: "https://notification.hire3x.com/",
});

const imageVerify = axios.create({
	baseURL: "https://proctor.hire3x.com/",
});

const requestSuggestion = axios.create({
	baseURL: "https://suggestions.hire3x.com/",
});

const uploadService = axios.create({
	baseURL: "https://awsmultipart.hire3x.com/",
});

const verificationService = axios.create({
	baseURL: "https://recruitment-api.hire3x.com/",
});

const conv = axios.create({
	baseURL: "https://convert.hire3x.com/",
});

const atsPreview = axios.create({
	baseURL: "https://puppeteer.hire3x.com/"

});

const tetrisURL = axios.create({
	baseURL: "https://tetris-api.hire3x.com",
});

// ============================================================================
// REQUEST INTERCEPTORS
// ============================================================================

// ServiceCandidate - Authorization only
ServiceCandidate.interceptors.request.use(
	(config) => {
		const token = getToken();
		// const userID = getProcessedToken();
		if (token) {
			config.headers["Authorization"] = "Bearer " + token;
			// config.headers["userID"] = getProcessedToken();
		}

		if (Capacitor.isNativePlatform() && hasAccess()) {
			console.log("Native Platform");
			config.baseURL =
				"https://gateway.hire3x.com/candidate/";
		}

		return config;
	},
	(error) => {
		return Promise.reject(error);
	}
);

// ServiceCandidateParser - Authorization + userID
ServiceCandidateParser.interceptors.request.use(
	(config) => {
		const token = getToken();
		const userID = getProcessedToken();
		if (token) {
			config.headers["Authorization"] = "Bearer " + token;
		}
		if (userID) {
			config.headers["userID"] = userID;
		}
		return config;
	},
	(error) => {
		return Promise.reject(error);
	}
);

// serviceRecruitment - Authorization only
serviceRecruitment.interceptors.request.use(
	(config) => {
		const token = getToken();
		if (token) {
			config.headers["Authorization"] = "Bearer " + token;
		}
		return config;
	},
	(error) => {
		return Promise.reject(error);
	}
);

// serviceAssessment - Authorization only
serviceAssessment.interceptors.request.use(
	(config) => {
		const token = getToken();
		if (token) {
			config.headers["Authorization"] = "Bearer " + token;
		}
		return config;
	},
	(error) => {
		return Promise.reject(error);
	}
);

// serviceRequest - Authorization + userID
serviceRequest.interceptors.request.use(
	(config) => {
		const token = getToken();
		const userID = getProcessedToken();
		if (token) {
			config.headers["Authorization"] = "Bearer " + token;
		}
		if (userID) {
			config.headers["userID"] = userID;
		}
		return config;
	},
	(error) => {
		return Promise.reject(error);
	}
);

// serviveNotification - Authorization + userID
serviveNotification.interceptors.request.use(
	(config) => {
		const token = getToken();

		if (token) {
			config.headers["Authorization"] = "Bearer " + token;
		}
		return config;
	},
	(error) => {
		return Promise.reject(error);
	}
);

// requestSuggestion - userID only
requestSuggestion.interceptors.request.use(
	(config) => {
		const userID = getProcessedToken();
		if (userID) {
			config.headers["userID"] = userID;
		}
		return config;
	},
	(error) => {
		return Promise.reject(error);
	}
);

// imageVerify - Fixed userID
imageVerify.interceptors.request.use(
	(config) => {
		config.headers["userID"] = "5b935330-0f65-4492-b158-5e3e7b9b8bd4";
		return config;
	},
	(error) => {
		return Promise.reject(error);
	}
);

// ServiceAiInterviewer - Authorization + userID
ServiceAiInterviewer.interceptors.request.use(
	(config) => {
		const token = getToken();
		const userID = getProcessedToken();
		if (token) {
			config.headers["Authorization"] = "Bearer " + token;
		}
		if (userID) {
			config.headers["userID"] = userID;
		}
		return config;
	},
	(error) => {
		return Promise.reject(error);
	}
);

// paymentService - userID only
paymentService.interceptors.request.use(
	(config) => {
		const userID = getProcessedToken();
		if (userID) {
			config.headers["userID"] = userID;
		}
		return config;
	},
	(error) => {
		return Promise.reject(error);
	}
);

// trainingService - userID only
trainingService.interceptors.request.use(
	(config) => {
		const userID = getProcessedToken();
		if (userID) {
			config.headers["userID"] = userID;
		}
		return config;
	},
	(error) => {
		return Promise.reject(error);
	}
);



// uploadService - Conditional userID (skip for CVS)
uploadService.interceptors.request.use(
	(config) => {
		const isFormData = config.data instanceof FormData;
		let cvs = false;
		if (isFormData) {
			cvs = config.data.has("cvs") && config.data.get("cvs") === "true";
		} else {
			cvs = config.data?.cvs || false;
		}
		if (!cvs) {
			const userID = getProcessedToken();
			if (userID) {
				config.headers["userID"] = userID;
			}
		}
		return config;
	},
	(error) => {
		return error.response || error;
	}
);

// KeycloakAPIs - Conditional Authorization + userID
KeycloakAPIs.interceptors.request.use(
	(config) => {
		const token = getToken();
		if (token) {
			config.headers["Authorization"] = "Bearer " + token;
		}
		return config;
	},
	(error) => {
		return Promise.reject(error);
	}
);

// ============================================================================
// RESPONSE INTERCEPTORS
// ============================================================================

// Import refreshAccessToken dynamically to avoid circular dependency
let refreshAccessToken = null;

// ServiceCandidate - Token refresh on 403
ServiceCandidate.interceptors.response.use(
	(response) => response,
	async (error) => {
		if (
			hasAccess() &&((error.response == undefined || error.response.status == 403 ||
			error.response.status == 401) &&
			error.config.url != "/can/register")
		) {
			if (!refreshAccessToken) {
				const module = await import("./apiFunctions.js");
				refreshAccessToken = module.refreshAccessToken;
			}
			await refreshAccessToken();
			const token = getToken();
			if (token) {
				error.config.headers["Authorization"] = "Bearer " + token;
			}
			return axios(error.config);
		}
		return error.response || Promise.reject(error);
	}
);

// requestSuggestion - Token refresh on 401/403
requestSuggestion.interceptors.response.use(
	(response) => response,
	async (error) => {
		if (hasAccess() &&
			(error.response == undefined ||
			error.response.status == 403 ||
			error.response.status == 401)
		) {
			if (!refreshAccessToken) {
				const module = await import("./apiFunctions.js");
				refreshAccessToken = module.refreshAccessToken;
			}
			await refreshAccessToken();
			const token = getToken();
			if (token) {
				error.config.headers["Authorization"] = "Bearer " + token;
			}
			return axios(error.config);
		}
		return error.response || Promise.reject(error);
	}
);

// paymentService - Token refresh on 401/403
paymentService.interceptors.response.use(
	(response) => response,
	async (error) => {
		if (hasAccess() &&
			(error.response == undefined ||
			error.response.status == 403 ||
			error.response.status == 401)
		) {
			if (!refreshAccessToken) {
				const module = await import("./apiFunctions.js");
				refreshAccessToken = module.refreshAccessToken;
			}
			await refreshAccessToken();
			const token = getToken();
			if (token) {
				error.config.headers["Authorization"] = "Bearer " + token;
			}
			return axios(error.config);
		}
		return error.response || Promise.reject(error);
	}
);

// ============================================================================
// EXPORTS
// ============================================================================

export {
	ServiceAiInterviewer,
	SSOService,
	ServiceCandidate,
	ServiceCandidateParser,
	KeycloakAPIs,
	serviceRecruitment,
	trainingService,
	imageVerify,
	serviceAssessment,
	requestSuggestion,
	conv,
	getProcessedToken,
	tetrisURL,
	atsPreview,
	paymentService,
	serviveNotification,
	serviceRequest,
	uploadService,
	notificationAuth,
	websiteRequest,
	KeynodeService,
	verificationService,
	EmailService
};
